export default __webpack_public_path__ + "static/media/thumbnail.74402ba5.png";